import { Table } from 'antd';
import styled from 'styled-components';

const SelectedAgreement = () => {
  const columns = [
    {
      dataIndex: 'date',
      key: 'date',
      width: '33%'
    },
    {
      dataIndex: 'items',
      key: 'items',
      width: '33%'
    },
    {
      dataIndex: 'purpose',
      key: 'purpose',
      width: '33%'
    }
  ];

  const dataSource = [
    {
      date: '수집·이용 목적',
      items: '수집·이용하는 개인정보 항목',
      purpose: '보유기간'
    },
    {
      date: '마케팅 및 광고에의 활용 신규 서비스 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등',
      items: '성명, 생년월일, 휴대폰번호, 이메일주소, 아이디',
      purpose: '회원 탈퇴시까지'
    },
    {
      date: '맞춤형 서비스 제공에 이용',
      items: '상호주소, 계약 종류, 업태',
      purpose: '회원 탈퇴시까지 또는 동의 철회시까지'
    }
  ];

  return (
    <>
      <Text>
        ㈜엑스바디가 제공하는 서비스를 보다 원활하게 이용하도록 하기 위해서 그 수집 및 이용이 필요한
        개인정보이므로 해당 항목에 동의를 거부하시는 경우에도 위 개인정보를 수집 및 이용하는
        서비스를 제외하고 나머지 서비스에 대해서는 이용이 가능합니다.
      </Text>
      <Table
        dataSource={dataSource.map((item, index) => ({
          ...item,
          key: index
        }))}
        bordered
        columns={columns}
        showHeader={false}
        pagination={false}
      />
    </>
  );
};

export default SelectedAgreement;

const Text = styled.p`
  padding-bottom: 16px;
`;
